export default __webpack_public_path__ + "AbbisWayWordmark.6fde0aafb911835d6aa7cd3f2b435865.png";